import React from 'react'
import styled from 'styled-components'
import useHereMap from '../../../@hooks/useHereMap'
import here_mapStyles from './here_map.styles'

export interface HereMapAtomProps {
  lat: number | undefined
  lng: number | undefined
  api_key: string
  app_id: string
  ap_position: 'EDIT_LOCATION_SCREEN' | 'LANDING_SCREEN'
  setAddressBasedOnGeoCode?: (arg1: number, arg2: number) => Promise<unknown>
}

const StyledWrapper = styled.div`
  ${here_mapStyles}
`

const HereMapAtom: React.FC<HereMapAtomProps> = function (props) {
  const mapRef = useHereMap(props)

  return (
    <StyledWrapper>
      <div ref={mapRef} />
    </StyledWrapper>
  )
}

export default HereMapAtom
